export const NotificationTypeId = {
  NEWSLETTER_ARTICLE_REVIEW: 7,
  NEWSLETTER_ARTICLE_LIKE: 8,
  NEWSLETTER_ARTICLE_COMMENT: 9,
  NEWSLETTER_ARTICLE_SECTION_COMMENT: 10,
  NEWSLETTER_COMMENT_LIKE: 11,
  NEWSLETTER_COMMENT_REPLY: 12,
  NEWSLETTER_USER_FOLLOW: 13,
  NEWSLETTER_CREATE_RESPONSE: 14,
  NEWSLETTER_UPDATE_RESPONSE: 15,
  NEWSLETTER_ARTICLE_INVESTMENT: 16,
  NEWSLETTER_REPUTATION_POINTS: 17,
  NEWSLETTER_COMMENT_MENTION: 18,
  NEWSLETTER_ARTICLE_MENTION: 19,
  NEWSLETTER_CONTENT_FLAGGED: 20,
  NEWSLETTER_CONTENT_MODERATED: 21,
  CREATOR_PAYOUT_THRESHOLD: 22,
  ADMIN_CREATOR_PAYOUT_THRESHOLD: 23,
  CREATOR_PAYOUT_SUCCESS: 24,
  ADMIN_CREATOR_PAYOUT_SUCCESS: 25,
  ADMIN_CREATOR_PAYOUT_FAILED: 26,
  ARTICLE_MILESTONE_1000: 27
};
